/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_ChatbotInputs */

const en_privacy_section_2_item_chatbot = /** @type {(inputs: Privacy_Section_2_Item_ChatbotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI chatbot conversations`)
};

const lv_privacy_section_2_item_chatbot = /** @type {(inputs: Privacy_Section_2_Item_ChatbotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sarunas ar AI asistentu`)
};

/**
* | output |
* | --- |
* | "AI chatbot conversations" |
*
* @param {Privacy_Section_2_Item_ChatbotInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_chatbot = /** @type {((inputs?: Privacy_Section_2_Item_ChatbotInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_ChatbotInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_chatbot(inputs)
	return en_privacy_section_2_item_chatbot(inputs)
});